import type { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { UpsellGlpHeader, UpsellLandingPage } from 'generated/resources/datatable.graphql'

import { GlpButtonBlock } from 'modules/discover/components/LandingPageBlocks/GlpButtonBlock'

interface GlpHeaderBlockProps {
  block: UpsellGlpHeader
  slug: string
  landingPage: UpsellLandingPage
  currentUpsellOrigin: {
    request_source: string
    request_source_category?: string
    request_source_component?: string
  } | null
}

export const GlpHeaderBlock: FC<GlpHeaderBlockProps> = ({
  block,
  slug,
  landingPage,
  currentUpsellOrigin,
}) => {
  if (!block) {
    return null
  }

  return (
    <Box className="mx-auto" alignItems="center" textAlign="center" gap="s16" maxWidth="s600">
      {block?.sectionTitle && (
        <Text size="700" color="black" weight="bold">
          {block?.sectionTitle || ''}
        </Text>
      )}
      {block?.sectionSubtitle && (
        <Text size="400" className="mb-4">
          {block?.sectionSubtitle || ''}
        </Text>
      )}

      <Box gap="s16" flexDirection="row" justifyContent="center">
        {block?.actions &&
          block?.actions?.map((action) => (
            <GlpButtonBlock
              key={action?.id}
              block={action}
              slug={slug}
              landingPage={landingPage}
              currentUpsellOrigin={currentUpsellOrigin}
            />
          ))}
      </Box>
    </Box>
  )
}
